import dynamic from 'next/dynamic'

import { useIntl } from 'react-intl'

import ShareIcon from 'app/assets/icons/listing/share-icon.svg'
import Button, { ButtonProps } from 'app/components/base/Button'
import Text from 'app/components/base/Text'
import useModal from 'app/hooks/useModal'

import messages from './ShareButton.messages'

const ShareDialog = dynamic(() => import('./components/ShareDialog'), {
  ssr: false
})

type ShareButtonProps = {
  url: string
  media: string[]
  listingTitle: string
  sx?: ButtonProps['sx']
}

const ShareButton: RFC<ShareButtonProps> = ({ url, media, sx }) => {
  const { open, showModal, hideModal } = useModal()
  const intl = useIntl()

  return (
    <>
      <Button
        variant="text"
        startIcon={<ShareIcon />}
        size="small"
        sx={{ width: '88px', mt: 2, p: 0.5, ...sx }}
        onClick={showModal}
      >
        <Text
          variant="body2"
          sx={{
            color: 'primary.main',
            fontWeight: 500
          }}
        >
          {intl.formatMessage(messages.button)}
        </Text>
      </Button>

      {open && (
        <ShareDialog open={open} onClose={hideModal} url={url} media={media} />
      )}
    </>
  )
}

export default ShareButton
